import { useAppStore } from '@/store/useAppStore.ts'
import { NumericDisplay } from 'calc-controls'

export function MultiUnitOutput() {
  const result = useAppStore((s) => s.runtimeResult)

  if (!result?.runtimeHours) return null

  const effectiveCapacity = result.effectiveCapacityAh
  const effectiveEnergy = result.effectiveEnergyWh
  const effectiveKWh = effectiveEnergy / 1000

  const runtimeH = result.runtimeHours
  const runtimeMin = runtimeH * 60
  const runtimeDays = runtimeH / 24

  const loadA = result.effectiveLoadA
  const loadW = result.effectiveLoadW

  return (
    <div className="multi-unit-output">
      <h3 className="multi-unit-output__title">Equivalent Values</h3>
      <p className="result-caption">Converted from effective (post-derating) capacity and load at the configured voltage.</p>
      <div className="multi-unit-output__grid">
        <div className="multi-unit-output__item">
          <NumericDisplay label="Capacity" value={effectiveCapacity} unit="Ah" decimals={2} />
          <NumericDisplay label="" value={effectiveEnergy} unit="Wh" decimals={1} />
          <NumericDisplay label="" value={effectiveKWh} unit="kWh" decimals={4} />
        </div>
        <div className="multi-unit-output__item">
          <NumericDisplay label="Runtime" value={runtimeH} unit="h" decimals={2} />
          <NumericDisplay label="" value={runtimeMin} unit="min" decimals={1} />
          <NumericDisplay label="" value={runtimeDays} unit="days" decimals={2} />
        </div>
        <div className="multi-unit-output__item">
          <NumericDisplay label="Load" value={loadA} unit="A" decimals={2} />
          <NumericDisplay label="" value={loadW} unit="W" decimals={1} />
        </div>
      </div>
    </div>
  )
}
